export default function checkIsTicketTypeShownInQuery(ticketTypeReference, query) {
  if (!query.show_tickets) return false;

  const showTicketTypes = query.show_tickets.split(',').map(ticketType => ticketType.trim());

  return showTicketTypes.includes(ticketTypeReference);
}
